"use client";

import { signup } from "@/lib/supabase/auth";
import { useActionState } from "react";

const initialState = {
  error: null,
};

export function SignupForm() {
  const [state, formAction] = useActionState(signup, initialState);
  return (
    <form action={formAction}>
      <div className="mb-6">
        <div className="flex justify-between mb-2">
          <label htmlFor="password" className="text-sm text-gray-600">
            ニックネーム
          </label>
        </div>
        <input
          type="nickname"
          name="nickname"
          id="nickname"
          placeholder="nickname"
          className="w-full px-3 py-2 placeholder-gray-300 border border-gray-300 rounded-md focus:outline-hidden focus:ring-3 focus:ring-indigo-100 focus:border-indigo-300 "
        />
      </div>
      <div className="mb-6">
        <label htmlFor="email" className="block mb-2 text-sm text-gray-600">
          メールアドレス
        </label>
        <input
          type="email"
          name="email"
          id="email"
          placeholder="you@example.com"
          className="w-full px-3 py-2 placeholder-gray-300 border border-gray-300 rounded-md focus:outline-hidden focus:ring-3 focus:ring-indigo-100 focus:border-indigo-300"
        />
      </div>
      <div className="mb-6">
        <div className="flex justify-between mb-2">
          <label htmlFor="password" className="text-sm text-gray-600">
            パスワード
          </label>
        </div>
        <input
          type="password"
          name="password"
          id="password"
          placeholder="Your Password"
          className="w-full px-3 py-2 placeholder-gray-300 border border-gray-300 rounded-md focus:outline-hidden focus:ring-3 focus:ring-indigo-100 focus:border-indigo-300 "
        />
      </div>
      {state.error && (
        <div className="mb-4 p-4 text-red-700 bg-red-100 rounded-md">
          {state.error}
        </div>
      )}
      <div className="mb-6">
        <button
          type="submit"
          className="w-full px-3 py-4 text-white bg-indigo-500 rounded-md focus:bg-indigo-600 focus:outline-hidden"
        >
          新規登録
        </button>
      </div>
    </form>
  );
}
